module.exports = __webpack_public_path__ + "img/sii--avatar.44df79ac.svg";